// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImgBox-module__ui-ImgBox--tpal1 {
  flex-shrink: 0;
  border: 1px solid var(--img-box-border-color, var(--chaek-color-border-divider));
  box-shadow: var(--img-box-shadow, 0 2px 6px rgb(0 0 0 / 14%));
}

.ImgBox-module__ui-ImgBox--tpal1 > img {
  display: block;
  width: 100%;
  height: auto;
}

.ImgBox-module__size-x-small--CD7mP,
.ImgBox-module__size-small--P8tq0,
.ImgBox-module__size-medium--dC1p9,
.ImgBox-module__size-large--N4Lla,
.ImgBox-module__size-x-large--EypA_ {
  box-sizing: border-box;
  overflow: hidden;
}

.ImgBox-module__size-x-small--CD7mP > img,
.ImgBox-module__size-small--P8tq0 > img,
.ImgBox-module__size-medium--dC1p9 > img,
.ImgBox-module__size-large--N4Lla > img,
.ImgBox-module__size-x-large--EypA_ > img {
  object-fit: cover;
}

.ImgBox-module__is-reverse--ADVl7 {
  --img-box-border-color: rgb(255 255 255 / 15%);
  --img-box-shadow: 0 2px 6px rgb(255 255 255 / 14%);
}

.ImgBox-module__size-x-small--CD7mP,
.ImgBox-module__size-small--P8tq0,
.ImgBox-module__size-medium--dC1p9 {
  border-radius: 2px;
}

.ImgBox-module__size-x-small--CD7mP {
  width: 44px;
}

.ImgBox-module__size-small--P8tq0 {
  width: 58px;
}

.ImgBox-module__size-medium--dC1p9 {
  width: 64px;
}

.ImgBox-module__size-large--N4Lla {
  width: 125px;
}

.ImgBox-module__size-x-large--EypA_ {
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/ImgBox/ImgBox.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gFAAgF;EAChF,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ui-ImgBox {\n  flex-shrink: 0;\n  border: 1px solid var(--img-box-border-color, var(--chaek-color-border-divider));\n  box-shadow: var(--img-box-shadow, 0 2px 6px rgb(0 0 0 / 14%));\n}\n\n.ui-ImgBox > img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.size-x-small,\n.size-small,\n.size-medium,\n.size-large,\n.size-x-large {\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.size-x-small > img,\n.size-small > img,\n.size-medium > img,\n.size-large > img,\n.size-x-large > img {\n  object-fit: cover;\n}\n\n.is-reverse {\n  --img-box-border-color: rgb(255 255 255 / 15%);\n  --img-box-shadow: 0 2px 6px rgb(255 255 255 / 14%);\n}\n\n.size-x-small,\n.size-small,\n.size-medium {\n  border-radius: 2px;\n}\n\n.size-x-small {\n  width: 44px;\n}\n\n.size-small {\n  width: 58px;\n}\n\n.size-medium {\n  width: 64px;\n}\n\n.size-large {\n  width: 125px;\n}\n\n.size-x-large {\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-ImgBox": `ImgBox-module__ui-ImgBox--tpal1`,
	"size-x-small": `ImgBox-module__size-x-small--CD7mP`,
	"size-small": `ImgBox-module__size-small--P8tq0`,
	"size-medium": `ImgBox-module__size-medium--dC1p9`,
	"size-large": `ImgBox-module__size-large--N4Lla`,
	"size-x-large": `ImgBox-module__size-x-large--EypA_`,
	"is-reverse": `ImgBox-module__is-reverse--ADVl7`
};
export default ___CSS_LOADER_EXPORT___;
